var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('center',[_c('div',{staticClass:"loader"},[_c('i',{staticClass:"fa fa-spinner fa-spin fa-5x fa-fw"})]),_c('transition',{attrs:{"name":"fade"}},[_c('h4',{staticClass:"loader-msg"},[_vm._v("Cargando datos...")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }